import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Badge, DataTable, SearchInput, Spin, useAlert } from '../ui';
import { DataTableColumn } from '../ui/DataTable';
import { useAuthHeader, useAuthUser } from 'react-auth-kit';
import User from '../../Models/User';
import datas from "../../Assets/data.json";
import Generate from '../Qm/Generate';
import AddServices from './Buttons/AddServices';
import FormService from './Forms/FormService';
import FormServiceUpdate from './Forms/FormServiceUpdate';
import FormDrawer from '../ui/FormDrawer';
import InfoBar from '../ui/InfoBar';
import PageHeader from '../ui/PageHeader';
import TableStatusBar from '../ui/TableStatusBar';
import { Crypter } from '../../Functions/Security/Crypter';
import env from 'react-dotenv';
import UpdateService from './Buttons/UpdateService';
import BlockDeblockService from './Buttons/BlockDeblockService';

export default function GestionServices() {

    // USER TOKEN
    const authHeader = useAuthHeader()
    // USER SESSION
    const auth = useAuthUser()
    const user: User = JSON.parse(JSON.stringify(auth() || {}))
    const alert = useAlert()

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [data, setData] = useState([])

    const [dataTri, setDataTri] = useState<any>([])

    const [loading, selLoading] = useState(false)
    const [textRes, setTextRes] = useState("")

    const [arrierePlan, setArrierePlan] = useState([])
    const [arrierePlanSelected, setArrierePlanSelected] = useState<any>()

    // CodeS
    // Libelle
    // Location
    // DateCreated
    // ModifDate
    // UpdateCount
    // CreatedBy
    // IsActif
    // Level
    // Statut
    // DeleteDate
    // DeleteCount
    // CodeS

    const columns: DataTableColumn[] =
        [
            { field: 'CodeS', headerName: 'Code service', width: 100 },
            { field: 'Libelle', headerName: 'Libelle', width: 150 },
            { field: 'DateCreated', headerName: 'Date création', width: 150 },
            { field: 'CodeFiliale', headerName: 'Code Filiale', width: 150 },
            { field: 'Location', headerName: 'Localisation', width: 150 },
            {
                field: 'Statut', headerName: 'Statut', width: 70, renderCell: ({ value }) => (
                    <Badge color={value == 1 ? "blue" : "red"}>
                        {value == 1 ? "actif" : "bloqué"}
                    </Badge>
                ),
            },
            {
                field: 'Actions', headerName: 'Actions', width: 150, sortable: false,
                renderCell: ({ value }) => (
                    <div className="flex items-center gap-2">
                        <UpdateService handleFunction={() => { LoadData() }} service={dataTri.find((ar: any) => (ar.id == value))} />
                        <BlockDeblockService handleFunction={() => { LoadData() }} service={dataTri.find((ar: any) => (ar.id == value))} />
                    </div>
                ),
            },
        ];



    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    useEffect(() => {
        LoadData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    function LoadData() {
        selLoading(true)
        const codeAbonne = user.CodeAbonne
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: env.API_BASE_URL + datas.API_LINKs.GetAllServices + Crypter.encrypt(codeAbonne),
            headers: {
                'Accept': 'text/plain',
                'Authorization': authHeader(),
            }
        };

        axios.request(config)
            .then((response: any) => {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value
                if (res.StatutCode == 200) {
                    selLoading(false)

                    const services: any = []
                    const ap: any = []

                    res.Result.map((g: any) => {
                        if (g.Statut != 2) {
                            services.push({ id: g.CodeS, CodeS: g.CodeS, Libelle: g.Libelle, DateCreated: g.DateCreated, Statut: g.Statut, CodeFiliale: g.CodeFiliale, Actions: g.CodeS, Location: g.Location }
                            )
                            ap.push({ id: g.CodeS, ModifDate: g.ModifDate, UpdateCount: g.UpdateCount, CreatedBy: g.CreatedBy })
                        }
                    })

                    setDataTri(services)
                    setArrierePlan(ap)


                }
                else {
                    selLoading(false)
                    setDataTri([])
                    //localStorage.setItem("tabGuichet", JSON.stringify([]))
                    setTextRes("")
                    alert.warning(res.Message)
                }
            })
            .catch((error: any) => {
                setTextRes("")
                alert.error('Error', error)
                selLoading(false)
                console.log(error);
            });
    }

    function handleRowClick(e: any) {
        setArrierePlanSelected(arrierePlan.find((ar: any) => (ar.id == e.id)))
    }

    function Search(search: string) {
        const data = {
            Critere: search,
            CodeAbonne: user.CodeAbonne
        }
        if (search.length == 0) {
            LoadData()
        }
        else {
            selLoading(true)
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: env.API_BASE_URL + datas.API_LINKs.ServicesGetBy + Crypter.encrypt(JSON.stringify(data)),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': authHeader(),
                }
            };

            axios.request(config)
                .then((response: any) => {
                    const res = JSON.parse(Crypter.decrypt(response.data)).Value
                    if (res.StatutCode == 200) {
                        selLoading(false)

                        const services: any = []
                        const ap: any = []

                        res.Result.map((g: any) => {
                            if (g.Statut != 2) {
                                services.push({ id: g.CodeS, CodeS: g.CodeS, Libelle: g.Libelle, DateCreated: g.DateCreated, Statut: g.IsActif, CodeFiliale: g.CodeFiliale, Actions: g.CodeS, Location: g.Location, Phone: g.Phone }
                                )
                                ap.push({ id: g.CodeS, ModifDate: g.ModifDate, UpdateCount: g.UpdateCount, CreatedBy: g.CreatedBy })
                            }
                        })

                        setDataTri(services)
                        setArrierePlan(ap)


                    }
                    else {
                        selLoading(false)
                        setDataTri([])
                        setTextRes("")
                        alert.warning(res.Message)
                    }
                })
                .catch((error: any) => {
                    setTextRes("")
                    alert.error('Error', error)
                    selLoading(false)
                    console.log(error);
                });
        }

    }

    const [open, setOpen] = useState(false)
    const [service, setservice] = useState<any>()

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    return (
        <Spin spinning={loading} >
            <PageHeader
                title="Gestion des services"
                subtitle="Paramétrez les services, leurs informations et leur statut"
                actions={<AddServices handleFunction={() => { LoadData() }} />}
            />
            <div className="eb-table-wrap">
                <SearchInput onSearch={Search} size='lg' className="mb-3" placeholder='Saisissez pour effectuer une recherche profonde' />
                <DataTable onRowClick={handleRowClick} rows={dataTri} height={300} columns={columns} searchable />
            </div>
            <TableStatusBar count={dataTri.length} loading={loading} onRefresh={LoadData} />
            <InfoBar data={[
                { label: 'Date Modif', value: arrierePlanSelected?.ModifDate },
                { label: 'Nombre de Modif', value: arrierePlanSelected?.UpdateCount },
                { label: 'Créé par', value: arrierePlanSelected?.CreatedBy },
            ]} />

            <FormDrawer
                open={open}
                onClose={handleClose}
                title={`Modification du service ${service?.Libelle || ''}`}
                hint="Les informations existantes sont pré-remplies. Modifiez les champs souhaités puis enregistrez."
            >
                <FormServiceUpdate handleFunction={() => { setOpen(false); LoadData() }} service={service} />
            </FormDrawer>
        </Spin>
    );
}
